import { Select } from 'antd'

export function PaginationBar({
  page,
  totalRows,
  pageSize,
  onPageChange,
}: {
  page: number
  totalRows: number
  pageSize: number
  onPageChange: (p: number) => void
}) {
  const pageCount = Math.ceil(totalRows / pageSize)
  if (pageCount <= 1) return null
  const options = Array.from({ length: pageCount }, (_, i) => ({ value: i + 1, label: String(i + 1) }))
  const start = (page - 1) * pageSize + 1
  const end = Math.min(page * pageSize, totalRows)
  return (
    <div className="flex items-center justify-between px-3 py-2 border-t border-gray-100 text-xs text-gray-500 bg-white sticky bottom-0">
      <span>{start}–{end} of {totalRows}</span>
      <div className="flex items-center gap-1">
        <button onClick={() => onPageChange(1)} disabled={page === 1} className="px-2 py-1 rounded border border-gray-200 disabled:opacity-40 hover:bg-gray-50">«</button>
        <button onClick={() => onPageChange(page - 1)} disabled={page === 1} className="px-2 py-1 rounded border border-gray-200 disabled:opacity-40 hover:bg-gray-50">Prev</button>
        <Select
          size="small"
          showSearch
          value={page}
          onChange={onPageChange}
          options={options}
          style={{ width: 72 }}
          filterOption={(input, opt) => opt?.label?.startsWith(input) ?? false}
        />
        <button onClick={() => onPageChange(page + 1)} disabled={page === pageCount} className="px-2 py-1 rounded border border-gray-200 disabled:opacity-40 hover:bg-gray-50">Next</button>
        <button onClick={() => onPageChange(pageCount)} disabled={page === pageCount} className="px-2 py-1 rounded border border-gray-200 disabled:opacity-40 hover:bg-gray-50">»</button>
      </div>
    </div>
  )
}
